<template>
  <div :class="['swiper',cclass]">
    <swiper :options="options">
      <swiper-slide v-for="(item,index) in imgs" :key="index">
        <img
          class="gallary-img"
          :src="item.banImg"
           @click="itemClick(item)"
        />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "CommonGallary",
  props: {
    imgs: {
      type: Array,
      default() {
        return [];
      }
    },
    cclass: {
      type: String(),
      default: ""
    },
    options: {
      type: Object,
      default() {
        return {
          pagination: ".swiper-pagination",
          paginationType: "fraction",
          autoplayDisableOnInteraction : false,
          // observeParents: true,
          autoplay: 3000,
          speed: 1000,
          loop:false
        };
      }
    }
  },
  data() {
    return {};
  },
   computed: {
    ...mapState({
      common: state => state.common
    })
  },
  methods: {
    itemClick (item) {
      console.log(item)
      if (item.bannerType === 1) {
        // 跳转活动详情
        var url = `/activityDetails/${item.activeId}`;
        if(this.common.cityId){
          url =url +"?cityId="+this.common.cityId
        }else if(this.common.marketInfo.id){
          url =url +"?marketId="+this.common.marketInfo.id
        }
      this.$router.push(url);
       // this.$router.push(`/activityDetails/${item.activeId}`)
      } else if (item.bannerType === 2) {
        //  window.location.href = item.banUrl

        localStorage.setItem("src",item.banUrl)
        // 跳转地址
        this.$router.push(`/iframePage`)
      } else if (item.bannerType === 3) {
        // 静态图片
      }else if(item.bannerType === 4){
          window.location.href = item.banUrl
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.swiper {
  height: 100%;
  width: 100%;
}
.swiper-container {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
}
.swiper-wrapper {
  width: 100% !important;
  height: 100% !important;
  position: relative;
}
.swiper-slide {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.gallary-img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}
/deep/ .swiper-pagination {
  color: #000;
  position: absolute;
  left: auto;
  right: 0.2rem;
  bottom: 0.2rem;
  display: inline-block;
  text-align: center;
  width: 0.8rem;
  height: 0.4rem;
  line-height: 0.4rem;
  color: #fff;
  font-size: 0.2rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0.04rem;
  .swiper-pagination-current {
    font-size: 0.28rem !important;
  }
}
</style>
